export default "__VITE_ASSET__D$Rxya5l__"